<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <div id="map-container" class="pa-4" style="width: 100%;height: 800px;"></div>
      <!--<div id="information" class="information"></div>-->
      <div id="popup" class="ol-popup">
        <a href="#" id="popup-closer" class="ol-popup-closer"></a>
        <div id="popup-content"></div>
    </div>
    <table class="legend_table">
      <tbody>
        <tr class="legend_row">
          <td class="legend_cell"><div class="legend_color" style="border: none;border-radius: 10px;margin-right: 5px;background-color: rgb(255, 124, 0, 0.5);"></div><div class="legend_label">{{ $t('Number of Disaster Per Province') }}</div></td>
        </tr>        
      </tbody>
    </table>

  </v-container>
</template>

<script>
  import 'ol/ol.css';
  import GeoJSON from 'ol/format/GeoJSON';
  import Map from 'ol/Map';
  import View from 'ol/View';
  import {fromLonLat/*, toLonLat*/} from 'ol/proj';
  import VectorSource from 'ol/source/Vector';
  import VectorLayer from 'ol/layer/Vector';
  import TileLayer from 'ol/layer/Tile';
  import { Fill, Stroke, Style, Text, Icon } from 'ol/style';
  import { defaults as defaultInteractions, MouseWheelZoom, DoubleClickZoom, DragPan } from 'ol/interaction';

  //import OSM from 'ol/source/OSM';
  
  import laosData from '@/assets/laoPDR.json';
  import roadData from '@/assets/roads_osm.json';

  import Feature from 'ol/Feature';
  import Overlay from 'ol/Overlay';
  import Point from 'ol/geom/Point';
  import Circle from 'ol/geom/Circle';

  //import {toStringHDMS} from 'ol/coordinate';

  export default {
    name: 'DisasterMgtMap',
    data: () => ({
    }),
    mounted: function() {

      /**
       * Elements that make up the popup.
       */
      const container = document.getElementById('popup');
      const content = document.getElementById('popup-content');
      const closer = document.getElementById('popup-closer');

      /**
       * Create an overlay to anchor the popup to the map.
       */
      const overlay = new Overlay({
        element: container,
        autoPan: {
          animation: {
            duration: 250,
          },
        },
      });

      /**
       * Add a click handler to hide the popup.
       * @return {boolean} Don't follow the href.
       */
      closer.onclick = function () {
        overlay.setPosition(undefined);
        closer.blur();
        return false;
      };

      /***************** Province *******************************/

      var laosSource = new VectorSource({
        features: new GeoJSON().readFeatures(laosData),
        format: new GeoJSON(),
        crossOrigin: 'anonymous'
      });

      var laosLayer = new VectorLayer({
        renderMode: 'image',
        source: laosSource,
        style: styleLaosFunction
      });

      var defaultStyleLaos = new Style({
        fill: new Fill({
          color: 'white',
        }),
        stroke: new Stroke({
          color: '#DCDCDC',
          width: 1,
        })
      });

      // the style function returns an array of styles for the given feature and resolution.
      // Return null to hide the feature.
      function styleLaosFunction(feature, resolution) {
          /*if(feature.get('name_en') === 'P. ATTAPU' || feature.get('name_en') === 'P. CHAMPASAK'){
            var style = new Style({
              fill: new Fill({
                color: '#fc9090'
              }),
              stroke: new Stroke({
                color: '#DCDCDC',
                width: 1,
              })
            });
            return [style];

          }else if(feature.get('name_en') === 'VIENTIANE CAPITAL' || feature.get('name_en') === 'P. HOUAPHAN'){
            var style = new Style({
              fill: new Fill({
                color: '#fad57f'
              }),
              stroke: new Stroke({
                color: '#DCDCDC',
                width: 1,
              })
            });
            return [style];

          }else if(feature.get('name_en') === 'P. LOUANGNAMTHA'){
            var style = new Style({
              fill: new Fill({
                color: '#d1fa7f'
              }),
              stroke: new Stroke({
                color: '#DCDCDC',
                width: 1,
              })
            });
            return [style];

          }else{*/
            return [defaultStyleLaos];
          //}
      }

      var transparentLayerSource = new VectorSource({
        features: new GeoJSON().readFeatures(laosData),
        format: new GeoJSON(),
        crossOrigin: 'anonymous'
      });

      var transparentLayer = new VectorLayer({
        renderMode: 'image',
        source: transparentLayerSource,
        style: styleTransparentFunction
      });

      function styleTransparentFunction(feature, resolution) {

        return [
          new Style({
              fill: new Fill({
                color: '#ff000000'
              }),
              stroke: new Stroke({
                color: '#ff000000',
                width: 1,
              })
            })
        ];

      }

      var view = new View({
        /*center: [0, 0],
        zoom: 2,*/
        center: fromLonLat([0.0009340, 0.000156]),
        zoom: 23.5
      });


      /***************** Road *******************************/
      var roadSource = new VectorSource({
        features: new GeoJSON().readFeatures(roadData),
        format: new GeoJSON(),
        crossOrigin: 'anonymous'
      });

      var roadLayer = new VectorLayer({
        renderMode: 'image',
        source: roadSource,
        style: styleRoadFunction
      });

      var defaultStyleRoad = new Style({
        fill: new Fill({
          color: '#808080',
        }),
        stroke: new Stroke({
          color: '#808080',
          width: 1,
        })
      });

      // the style function returns an array of styles for the given feature and resolution.
      // Return null to hide the feature.
      function styleRoadFunction(feature, resolution) {
          /*if(feature.get('osm_id') === 755892545 || feature.get('osm_id') === 115238250 || feature.get('osm_id') === 323858187 || feature.get('osm_id') === 115238506 || feature.get('osm_id') === 30000778 || feature.get('osm_id') === 115238506 || feature.get('osm_id') === 323865466 || feature.get('osm_id') === 115238194 || feature.get('osm_id') === 115238366 || feature.get('osm_id') === 216302071 || feature.get('osm_id') === 686956274 || feature.get('osm_id') === 545791191 || feature.get('osm_id') === 545761838 || feature.get('osm_id') === 115238548 || feature.get('osm_id') === 115238513 || feature.get('osm_id') === 545761161){

            var style = new Style({
              fill: new Fill({
                color: 'red'
              }),
              stroke: new Stroke({
                color: 'red',
                width: 6,
              })
            });
            return [style];

          }else{*/
            return [defaultStyleRoad];
          //}
      }


      /***************** Map *******************************/
      var map = new Map({
        target: 'map-container',
        layers: [
          /*new TileLayer({
            source: new OSM(),
          }),*/
          laosLayer,
          roadLayer
        ],
        overlays: [overlay],
        view: view,
        /*interactions: defaultInteractions({
          mouseWheelZoom: false,
          doubleClickZoom: false,
          dragPan: false
        }).extend([])*/
      });

      const marker = new Overlay({
        position: fromLonLat([0.000924, 0.0001795]),
        positioning: 'center',
        element: document.getElementById('marker'),
        stopEvent: false,
      });

      map.addOverlay(marker);

      /**
       * Add a click handler to the map to render the popup.
       */
      map.on('singleclick', function (evt) {
        const coordinate = evt.coordinate;

        const pixel = evt.pixel;

        //console.log(map);

        const feature = map.forEachFeatureAtPixel(pixel, function(feature) {
          return feature;
        });
        /*if (feature) {
          if (feature.get('name_en') !== undefined) {
            console.log("feature.get('name_en')");
            console.log(feature.get('name_en'));
          }
        }*/

        if(feature.get('name_en') === 'VIENTIANE CAPITAL'){

            content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
            content.innerHTML += '<p>Number of disaster:<span style="font-weight:bold;"> 1</span></p>';
            content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> Cyclone (1 time)</span></p>';
            content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> 40,000 mLAK</span></p>';
            content.innerHTML += '<p>Total People Affected:<span style="font-weight:bold;"> 9,000</span></p>';
            content.innerHTML += '<p>Total Woman Affected:<span style="font-weight:bold;"> 5,000</span></p>';
            content.innerHTML += '<p>Total Household Affected:<span style="font-weight:bold;"> 12,000</span></p>';
            content.innerHTML += '<p>Total Death:<span style="font-weight:bold;"> 10,492</span></p>';

        }else if(feature.get('name_en') === 'P. LOUANGNAMTHA'){

            content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
            content.innerHTML += '<p>Number of disaster:<span style="font-weight:bold;"> 1</span></p>';
            content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> Storm (1 time)</span></p>';
            content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> 50,000 mLAK</span></p>';
            content.innerHTML += '<p>Total People Affected:<span style="font-weight:bold;"> 8,000</span></p>';
            content.innerHTML += '<p>Total Woman Affected:<span style="font-weight:bold;"> 4,000</span></p>';
            content.innerHTML += '<p>Total Household Affected:<span style="font-weight:bold;"> 15,000</span></p>';
            content.innerHTML += '<p>Total Death:<span style="font-weight:bold;"> 1,862</span></p>';

        }else if(feature.get('name_en') === 'P. ATTAPU'){

            content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
            content.innerHTML += '<p>Number of disaster:<span style="font-weight:bold;"> 1</span></p>';
            content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> Flash Flood (1 time)</span></p>';
            content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> 30,000.15 mLAK</span></p>';
            content.innerHTML += '<p>Total People Affected:<span style="font-weight:bold;"> 4,000</span></p>';
            content.innerHTML += '<p>Total Woman Affected:<span style="font-weight:bold;"> 3,000</span></p>';
            content.innerHTML += '<p>Total Household Affected:<span style="font-weight:bold;"> 1,000</span></p>';
            content.innerHTML += '<p>Total Death:<span style="font-weight:bold;"> 1,045</span></p>';

        }else{
            content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
            content.innerHTML += '<p>Number of disaster:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total People Affected:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total Woman Affected:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total Household Affected:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total Death:<span style="font-weight:bold;"> /</span></p>';
        }

        overlay.setPosition(coordinate);
      });

        //LOCATION ICON LAYER
        var disasterLocation = [
          [102.2, 21.7],
          [101.1, 20.9],
          [100.6, 20.4],
          [101.8, 20.4],
          [102.6, 20],
          [104, 20.4],
          [101.4, 19],
          [102.2, 18.8],
          [103, 18.8],
          [102.7, 18],
          [103.4, 19.5],
          [104.4, 18.5],
          [105.4, 17.5],
          [105.8, 16.5],
          [106.3, 15.8],
          [105.8, 14.8],
          [107.1, 14.8],
          [107, 15.6]
        ];
        var disasterValue = [
          '', '1', '', '', '', '', '', '', '', '1', '', '', '', '', '', '', '1', ''
        ];
        var disasterWidth = [
          0, 0.15, 0, 0, 0, 0, 0, 0, 0, 0.15, 0, 0, 0 , 0 , 0, 0, 0.15, 0
        ];

        const iconDisasterSource = new VectorSource({
          features: [],
        });

        const iconDisasterLayer = new VectorLayer({
          source: iconDisasterSource,
        });

        for(let i = 0; i < disasterLocation.length; i++){

          const iconDisasterFeature = new Feature({
            geometry: new Point(disasterLocation[i]),
            name: 'Luang Prabang'
          });
          const iconDisasterStyle = new Style({
            text: new Text({
                   text: disasterValue[i],
                   font: 'bold 17px Calibri,sans-serif',
                   fill: new Fill({ color: 'black' }),
                   color: '#fff', 
                   width: 2,
                   textAlign: 'center',
                   textBaseline: 'hanging',               
                   offsetX : 0,
                   offsetY : -5,           
                   declutter: true,
                   overflow: true
           })
          });
          iconDisasterFeature.setStyle(iconDisasterStyle);
          iconDisasterLayer.getSource().addFeature(iconDisasterFeature);

        }

        map.addLayer(iconDisasterLayer);

        for(let i = 0; i < disasterLocation.length; i++){
          const circleDisasterLayer = new VectorLayer({
            source: new VectorSource({
              features: [new Feature(new Circle(disasterLocation[i],disasterWidth[i]))]
            }),
            style: [
                    new Style({
                      stroke: new Stroke({
                        color: 'rgb(255, 124, 0, 0.5)',
                        width: 1
                      }),
                      fill: new Fill({
                        color: 'rgb(255, 124, 0, 0.5)'
                      })
                    })
                  ]
          }); 
          map.addLayer(circleDisasterLayer);
        }

        map.addLayer(transparentLayer);



   }

  }
</script>

<style>
  .row {
    margin: 0px;
  }
  .pd-0 {
    padding: 7px;
  }
  .v-application p {
      margin-bottom: 5px;
      font-size: 13px;
  }
  #information {
    display: flex;
    flex-direction: row;
    background-color: #ffffff;
    font-size: 10px;
    color: #212121;
    z-index: 100;
    position: relative;
    padding: 5px;
  }

  #marker {
    width: 20px;
    height: 20px;
    opacity: 1;
  }

  .ol-popup {
    position: absolute;
    background-color: white;
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    bottom: 12px;
    left: -50px;
    min-width: 310px;
  }
  .ol-popup:after, .ol-popup:before {
    top: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  .ol-popup:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
  }
  .ol-popup:before {
    border-top-color: #cccccc;
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
  }
  .ol-popup-closer {
    text-decoration: none;
    position: absolute;
    top: 2px;
    right: 8px;
  }
  .ol-popup-closer:after {
    content: "✖";
  }

</style>
